<div class="ao">
  <div class="ao-fej">
    <div>
      <h3>Dolgozói fiókok összevonása</h3>
      <div class="sugo">
        Ugyanaz a dolgozó több felhasználónévvel: a KIR-import, az aSc-import és a kézi felvétel
        más-más azonosítót adhat neki (<code>nev.pelda</code> és <code>nev.pelda&#64;iskola.hu</code>,
        vagy <code>.2</code> végződéssel). A két fiók alatt megoszlik az órarend, az értékelés és a
        jelenlét, a dolgozó pedig csak az egyikkel lép be – a másikban lévő munka így „eltűnik".
        <br>A párt <b>minden intézményben</b> keressük (a duplikátum tipikusan épp egy másik
        feladatellátásnál keletkezik), de csak akkor mutatjuk, ha van benne saját dolgozó.
      </div>
    </div>
    <ion-button size="small" fill="outline" (click)="betolt()" [disabled]="toltodik || fut">
      <ion-icon slot="start" name="refresh-outline"></ion-icon>Frissítés
    </ion-button>
  </div>

  <ion-spinner name="crescent" *ngIf="toltodik"></ion-spinner>

  <div class="ao-ures" *ngIf="duplikatumok && !duplikatumok.length && !toltodik">
    Nincs duplikátum-jelölt: minden dolgozónak egy fiókja van.
  </div>

  <ng-container *ngIf="duplikatumok?.length">
    <div class="ao-muvelet">
      <b>{{ duplikatumok.length }} jelölt</b>
      <ion-button size="small" color="secondary" (click)="tomegesProba()" [disabled]="fut">
        Tömeges próba
      </ion-button>
      <ion-button size="small" color="danger" (click)="tomegesVegleges()"
                  [disabled]="fut || !tomegesTerv?.osszesites?.osszevonhato">
        <ion-icon slot="start" name="git-merge-outline"></ion-icon>
        Egyértelműek összevonása{{ tomegesTerv ? ' (' + tomegesTerv.osszesites.osszevonhato + ')' : '' }}
      </ion-button>
      <ion-spinner name="crescent" *ngIf="fut"></ion-spinner>
    </div>

    <div class="ao-doboz" *ngIf="tomegesTerv">
      <b>Tömeges próba:</b> {{ tomegesTerv.osszesites.osszevonhato }} egyértelműen összevonható,
      {{ tomegesTerv.osszesites.bizonytalan }} bizonytalan (ezekhez nem nyúlunk)
      <span *ngIf="tomegesTerv.osszesites.hibas" style="color:#c5221f">,
        {{ tomegesTerv.osszesites.hibas }} hibára futna</span>.
    </div>

    <!-- A jelöltek -->
    <div class="ao-jelolt" *ngFor="let j of duplikatumok" [class.bizonytalan]="j.bizonytalan">
      <div class="ao-jelolt-fej">
        <b>{{ j.nev }}</b>
        <span class="cimke">{{ j.fiokok.length }} fiók</span>
        <span class="cimke halvany">egyezés: {{ j.alap }}</span>
        <span class="cimke figyelem" *ngIf="j.bizonytalan">ellenőrizd!</span>
        <ion-button size="small" fill="outline" (click)="megnyit(j)">Összevonás…</ion-button>
      </div>
      <div class="ao-fiok" *ngFor="let f of j.fiokok">
        <span class="azon">{{ f.adid }}</span>
        <span class="halvany" *ngIf="f.oktazon">okt: {{ f.oktazon }}</span>
        <span class="halvany" *ngIf="f.email">{{ f.email }}</span>
        <span class="halvany">{{ f.intezmenyek || '– nincs feladatellátás –' }}</span>
        <span class="db" [class.nulla]="!f.osszes">{{ f.osszes }} adatsor</span>
      </div>
    </div>
  </ng-container>

  <!-- Munkalap -->
  <div class="ao-munkalap" *ngIf="munkalap">
    <h4>Összevonás – {{ munkalap.nev }}</h4>
    <div class="ao-doboz figyelem" *ngIf="munkalap.bizonytalan">
      <b>Ellenőrizd, mielőtt összevonod!</b>
      <div>{{ munkalap.bizonytalan_ok }}</div>
    </div>
    <div class="sugo">
      A <b>megmaradó</b> fiók az, amelyikkel a dolgozó <b>ténylegesen belép</b>: a Keycloak-fiókokhoz
      nem nyúlunk, tehát a beolvadó névvel utána is be lehet lépni, csak nem lesz mögötte adat.
    </div>

    <table class="ao-tabla">
      <thead><tr><th>Marad</th><th>Beolvad</th><th>Fiók</th><th>Adat</th></tr></thead>
      <tbody>
        <tr *ngFor="let f of munkalap.fiokok">
          <td><input type="radio" [checked]="munkalap.megmarad === f.adid"
                     (change)="megmaradValt(f.adid)" /></td>
          <td>
            <input type="checkbox" *ngIf="munkalap.megmarad !== f.adid"
                   [checked]="munkalap.beolvad.includes(f.adid)"
                   (change)="beolvadValt(f.adid)" />
          </td>
          <td>
            <div><b>{{ f.adid }}</b></div>
            <div class="halvany">{{ f.email }} <span *ngIf="f.oktazon">· okt: {{ f.oktazon }}</span></div>
            <div class="halvany">{{ f.intezmenyek }}</div>
          </td>
          <td class="halvany">
            <div *ngFor="let sor of hasznalatSorok(f)">{{ sor }}</div>
            <div *ngIf="!f.osszes">– nincs adat –</div>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="ao-muvelet">
      <ion-button size="small" color="secondary" (click)="proba()" [disabled]="fut">Próba</ion-button>
      <ion-button size="small" color="danger" (click)="vegleges()" [disabled]="fut || !terv">
        <ion-icon slot="start" name="git-merge-outline"></ion-icon>Összevonás véglegesen
      </ion-button>
      <ion-button size="small" fill="clear" (click)="munkalap = null; terv = null">Bezár</ion-button>
    </div>

    <div class="ao-doboz" *ngIf="terv">
      <b>{{ terv.dry_run ? 'Próba – ez történne:' : 'Kész:' }}</b>
      <div *ngIf="!terv.terv?.length" class="halvany">A beolvadó fiók alatt nincs adat – csak a fiók törlődik.</div>
      <table class="ao-tabla" *ngIf="terv.terv?.length">
        <thead><tr><th>Mi</th><th>Átkerül</th><th>Ütközés miatt eldobva</th></tr></thead>
        <tbody>
          <tr *ngFor="let t of terv.terv">
            <td>{{ t.leiras }}</td>
            <td>{{ t.db }} sor</td>
            <td [style.color]="t.utkozo ? '#8a6d00' : '#8a929e'">{{ t.utkozo || 0 }}</td>
          </tr>
        </tbody>
      </table>
      <div class="sugo" *ngIf="terv.atveendo && (terv.atveendo | json) !== '{}'">
        A megmaradó fiók ÜRES mezőibe átvesszük: {{ terv.atveendo | json }}
      </div>
      <div class="sugo">
        Ami ütközik (ugyanarra a napra/intézményre mindkét fióknak van sora), azt a beolvadó
        oldalról eldobjuk – a megmaradó fiók sora marad érvényben.
      </div>
    </div>
  </div>
</div>
